import { TrackType } from 'react-native-track-player';
export const contentToAudioTrack = (content, streamUrl = '') => {
    let artist = '';
    if (content.contributions) {
        artist = content.contributions
            .map((contrib) => contrib.contributor.name)
            .slice(0, 2)
            .join(', ');
    }
    return ({
        id: content.id,
        url: streamUrl,
        type: streamUrl.endsWith('.m3u8')
            ? TrackType.HLS
            : TrackType.Default,
        title: content.name,
        artist,
        artwork: content.cover?.src,
    });
};
//# sourceMappingURL=contentToAudioTrack.js.map